const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Formats a date to DD-MMM-YYYY, e.g. 12-Oct-2026
export const fmtDate = (v) => {
  if (!v || v === "-") return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v));
  if (m) return `${m[3]}-${MONTHS[+m[2] - 1]}-${m[1]}`;
  const d = new Date(v);
  if (isNaN(d)) return String(v);
  return `${String(d.getDate()).padStart(2, "0")}-${MONTHS[d.getMonth()]}-${d.getFullYear()}`;
};

// Formats a timestamp to DD-MMM-YYYY, HH:MM IST (Asia/Kolkata)
export const fmtDateTime = (v) => {
  if (!v) return "never";
  const d = new Date(v);
  if (isNaN(d)) return String(v);
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(d);
  const m = {};
  for (const p of parts) m[p.type] = p.value;
  return `${m.day}-${m.month.slice(0, 3)}-${m.year}, ${m.hour}:${m.minute} IST`;
};

// Today's date in IST as DD-MMM-YYYY
export const todayIST = () => fmtDate(new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(new Date()));

// "<Customer Name> - Report Dated - <DD-MMM-YYYY>" with filename-illegal characters removed
export const reportFileName = (name, ext) =>
  `${(name || "Customer").replace(/[\\/:*?"<>|]+/g, " ").replace(/\s+/g, " ").trim()} - Report Dated - ${todayIST()}.${ext}`;
